import React from 'react';
import { Link } from 'react-router-dom';
import AddboxImgRight from "../../../assets/images/gold_ad.png";
import { getlanguage } from "../../../helpers/changelanguage";
import './AddboxRight.css';


export default () => { 
    let  language = getlanguage();
    return (
        <div className="ad_box checkApp" >
            <img src={(language == 'en') ? '/assets/images/gold_ad.png' : '/assets/images/gold_ad_somali.png' } />
        </div>
    );
};